import { initialPagination } from '@app/constants/pagination';

const tableDataInit = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    uniqueOrganizationalEntities: [],
    uniqueFishtypes: [],
    uniqueWaterbodies: [],
  },
  summaryPerFishtype: [],
  loading: false,
  error: false,
};

export { tableDataInit };
